import browserUpdate from "browser-update";

export default browserUpdate({
  // Do not give the user the option to permanently hide the notification
  no_permanent_hide: true
});
